<template>
  <section>
    <v-dialog v-model="dialog" persistent max-width="750px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <v-flex>Add Users</v-flex>
          <v-btn icon @click="CloseDialog">
            <v-icon color="text--secondary">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex wrap style="padding: 10px;">
            <v-flex>
              <v-autocomplete
                v-model="Email"
                :items="items"
                :loading="isLoading"
                :search-input.sync="search"
                color="white"
                hide-no-data
                hide-selected
                item-text="Email"
                item-value="Email"
                placeholder="Search User by Email"
                return-object
                flat
                solo-inverted
                clearable
              ></v-autocomplete>
            </v-flex>
          </v-flex>
        </v-card-text>
        <v-flex style="font-size: 20px;padding: 0px 32px;">List Of Users :</v-flex>

        <v-layout
          v-for="(item , index ) in UserList"
          :key="index"
          row
          style="width: 50%;display: inline-block;"
        >
          <v-flex style="padding: 0 15px 0 50px;">
            <span>{{ index+1 }} . {{ item.Email }}</span>
            <v-btn icon color="error" @click="DeleteUser" :id="item._id+'_Btn'">
              <v-icon :id="item._id+'_Icon'">delete</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-flex style="text-align: right;">
            <v-btn color="success" @click="SubmitUser">Add User</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
export default {
  props: ["dialog"],
  data() {
    return {
      CurrentOffer: {},
      Email: {},
      entries: [],
      isLoading: false,
      search: null,
      UserList: []
    };
  },
  computed: {
    items() {
      return this.entries;
    }
  },
  watch: {
    search(val) {
      let data = {};
      data["Email"] = val;
      this.isLoading = true;
      
      this.$http
        .post(
          `${this.$store.getters.GetProductionUrl}/offers/searchusers`,
          data
        )
        .then(response => {
          this.entries = response["data"]["response"];
          this.isLoading = false;
        })
        .catch(err => {
          this.$eventHub.$emit("SNACK_BAR", {
            Show: true,
            Text: "Failed To Fetch Data",
            Color: "red",
            Close: false
          });
        });
    }
  },
  methods: {
    CloseDialog() {
      (this.CurrentOffer = {}),
        (this.Email = ""),
        (this.entries = []),
        (this.isLoading = false),
        (this.search = null),
        this.$emit("close");
    },
    SetCurrentOffer(CurrentOffer) {
      this.CurrentOffer = CurrentOffer;
      let data = { Offer_Id: CurrentOffer["_id"] };
      
      this.$http
        .post(
          `${this.$store.getters.GetProductionUrl}/offers/getofferusers`,
          data
        )
        .then(response => {
          this.UserList = response["data"]["response"];
        })
        .catch(err => {
          this.$eventHub.$emit("SNACK_BAR", {
            Show: true,
            Text: "Error While Uploading Data",
            Color: "red",
            Close: false
          });
        });
    },
    SubmitUser() {
      let data = {
        Offer_Id: this.CurrentOffer["_id"],
        User_Id: this.Email["_id"]
      };
      
      this.$http
        .post(
          `${this.$store.getters.GetProductionUrl}/offers/addusertooffer`,
          data
        )
        .then(response => {
          if (response["data"]["response"]) {
            this.UserList.push(response["data"]["response"]);
          } else {
            this.$eventHub.$emit("SNACK_BAR", {
              Show: true,
              Text: "User Already Added",
              Color: "red",
              Close: false
            });
          }
        })
        .catch(err => {
          this.$eventHub.$emit("SNACK_BAR", {
            Show: true,
            Text: "Error While Adding Offer",
            Color: "red",
            Close: false
          });
        });
    },
    DeleteUser(event) {
      let User_Id = event.target.id.split("_")[0];
      let data = { Offer_Id: this.CurrentOffer["_id"], User_Id: User_Id };
      
      this.$http
        .post(
          `${this.$store.getters.GetProductionUrl}/offers/deleteuserfromoffer`,
          data
        )
        .then(response => {
          let index = this.UserList.findIndex(x => x["_id"] == User_Id);
          this.UserList.splice(index, 1);
          this.$eventHub.$emit("SNACK_BAR", {
            Show: true,
            Text: "Successfully Deleted User",
            Color: "green",
            Close: false
          });
        })
        .catch(err => {
          this.$eventHub.$emit("SNACK_BAR", {
            Show: true,
            Text: "Error While Deleting User",
            Color: "red",
            Close: false
          });
        });
    }
  }
};
</script>
<style scoped>
</style>